import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { apiQuery } from "../../utils/api-config";
import { Response } from "../../types/response/Response";
import {
  BookingDTO,
  BookingSearchResponseBody,
  BookingStatisticDTO,
  BookingStatisticRequestParamDTO,
  BookingStatus,
  BookingUpdateDTO,
} from "../../types/booking/BookingDTO";
import { BookingExceptionDTO } from "../../types/bookingException/BookingExceptionDTO";
import { ExtraTimeRequestDTO } from "../../types/booking/ExtraTimeRequestDTO";
import { getUrl } from "../../utils/Constants";

export const bookingApi = createApi({
  reducerPath: "booking",
  baseQuery: apiQuery,
  tagTypes: ["bookings", "statuses", "statistics"],
  endpoints: (builder) => ({
    searchBookings: builder.query<
      Response<BookingDTO[]>,
      Partial<BookingSearchResponseBody>
    >({
      query: (body) => ({
        url: "/booking-search",
        method: "POST",
        body,
      }),
      providesTags: ["bookings"],
    }),
    getStatuses: builder.query<Response<BookingStatus[]>, void>({
      query: () => "/booking/statuses",
      providesTags: ["statuses"],
    }),

    getStatistics: builder.query<Response<BookingStatisticDTO>,BookingStatisticRequestParamDTO>({
      query: (params) => getUrl("/booking/statistics", params),
      providesTags: ["statistics"],
    }),

    updateBooking: builder.mutation<void, Partial<BookingUpdateDTO>>({
      query: (dto) => ({
        url: `/booking/${dto.id}`,
        method: "PATCH",
        body: dto,
      }),
      invalidatesTags: ["bookings"],
    }),

    createException: builder.mutation<void, Partial<BookingExceptionDTO>>({
      query: (dto) => ({
        url: "/exceptions",
        method: "POST",
        body: dto,
      }),
      invalidatesTags: ["bookings"],
    }),

    deleteException: builder.mutation<void, Partial<number>>({
      query: (id) => ({
        url: `/exceptions/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["bookings"],
    }),
    addExtraTimeToBranch: builder.mutation<
      Response<BookingDTO[]>,
      Partial<ExtraTimeRequestDTO>
    >({
      query: (body) => ({
        url: "/branches/additional-times",
        method: "POST",
        body,
      }),
      invalidatesTags: ["bookings"],
    }),
  }),
});

export const {
  useGetStatusesQuery,
  useLazyGetStatisticsQuery,
  useSearchBookingsQuery,
  useUpdateBookingMutation,
  useCreateExceptionMutation,
  useDeleteExceptionMutation,
  useAddExtraTimeToBranchMutation,
} = bookingApi;
